import React from 'react'
import './Modal.scss'

interface RezModalProps {
  headerTitleText: string
  htmlContentText: string
  toggleModal: (arg0: boolean) => void
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const Modal = ({ headerTitleText, htmlContentText, toggleModal }: RezModalProps) => {
  return (
    <div className='modal-background'>
      <div className='modal'>
        <div className='modal-content'>
          <header>
            <div className='close'>
              <h6 dangerouslySetInnerHTML={{ __html: headerTitleText }}></h6>
              <span
                className='close-btn'
                onClick={() => {
                  toggleModal(false)
                }}
              >
                &times;
              </span>
            </div>
          </header>
          <body dangerouslySetInnerHTML={{ __html: htmlContentText }}></body>
        </div>
      </div>
    </div>
  )
}

export default Modal
